<!--
 * @Description: 用户信息展示组件，由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-21 13:25:43
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="info">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/info' }">信息中心</el-breadcrumb-item>
                <el-breadcrumb-item>修改基本信息</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-modify-info bizcomp ' + className">
            <user-info />
        </div>
        <footer-questions
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userInfo from "@/components/acctInfo/userInfoDc";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "ModifyInfo",
    components: {
        userInfo,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            warningHtml: "",
            commonQuestion: [
                {
                    title: "使用农行卡开户、重置密码或换卡，跳转至银行页面后为何显示找不到请求记录？",
                    answer: "",
                    showFlag: false
                },
                {
                    title: "使用交行卡快捷开户或重置密码时，跳转至银联页面时提示未开通服务？",
                    answer: "",
                    showFlag: false
                },
                {
                    title: "使用浦发磁条卡开户或重置密码时，跳转到银联页面时提示未开通服务？",
                    answer: "",
                    showFlag: false
                }
            ]
        };
    },
    mounted() {
        this.warningHtml = `<p>1、亲爱的中银易商用户，请下载${
            this.$const.COMPANY
        }基金APP完成相关操作，官网、微信不支持该项目服务，给您带来的不便深表歉意。您可以拨打${
            this.$const.COMPANY
        }基金客服热线  <span style="color:red;">${this.$cache.getCompanyInfoParam(
            "10101009"
        )}</span>  进行咨询。</p>
                            <p class="mt5">2、如果您的支付银行卡为民生银行，无法自助找回交易密码，请联系客服  <span style="color:red;">${this.$cache.getCompanyInfoParam(
                                "10101009"
                            )}</span>  找回。</p>`;
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.bizcomp-modify-info {
    margin-top: 20px;
}
</style>
